// SectionHeader — заголовок секции по MD3 section-header (U-25 sled-V9,
// crm-ux-research.md p48/p74): слева иконка + title (+ subtitle опционально),
// справа — action (кнопка/ссылка; не рендерится если action не задан).
// Выравнивание space-between, gap 8px, action не сжимается.
import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface SectionHeaderProps {
  /** Заголовок секции (уже локализованная строка). */
  title: string;
  /** Иконка слева от заголовка (опционально). */
  icon?: ReactNode;
  /** Подзаголовок секции (опционально). */
  subtitle?: string;
  /** Действие справа (кнопка/ссылка; опционально). */
  action?: ReactNode;
}

/** Универсальный заголовок секции: label + action, action-справа. */
export function SectionHeader({ title, icon, subtitle, action }: SectionHeaderProps): JSX.Element {
  return (
    <Box
      data-testid="section-header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1,
        mb: 2,
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
        {icon ? (
          <Box sx={{ display: 'flex', color: 'text.secondary' }}>{icon}</Box>
        ) : null}
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', lineHeight: 1.3 }}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="caption" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Box>
      </Stack>
      {action ? <Box sx={{ flexShrink: 0 }}>{action}</Box> : null}
    </Box>
  );
}
